import React, { useState, InputHTMLAttributes } from 'react'
import { Field } from 'components'
import classnames from 'classnames'
import styles from './index.module.less'

interface InputProps extends InputHTMLAttributes<any> {
  error?: any
  className?: string
  addonAfter?: React.ReactNode | null | undefined
  placeholder?: string
  blur?: Function
  trim?: boolean
  inputStyle?: any
}

export default function Index({
  error = '',
  className = '',
  addonAfter = undefined,
  value = '',
  onFocus = () => {},
  blur = e => {},
  onBlur = e => {},
  onChange = e => {},
  inputStyle,
  trim,
  ...props
}: InputProps) {
  const [focus, setFocus] = useState(false)

  return (
    <Field
      error={error}
      className={classnames(
        className,
        styles.input,
        addonAfter ? styles.padRight : '',
        focus ? styles.borderColor : ''
      )}>
      <div className={styles.inputCont}>
        <input
          style={inputStyle ? { ...inputStyle } : { flex: 1 }}
          value={value}
          {...props}
          onFocus={e => {
            setFocus(true)
            onFocus(e)
          }}
          onChange={onChange}
          onBlur={e => {
            // 去掉前后空格
            let value = trim ? e.target.value.trim() : e.target.value
            let enent = { target: { value } } as any
            onChange(enent)
            setFocus(false)
            blur(enent)
            onBlur(enent)
          }}
        />
        {addonAfter}
      </div>
    </Field>
  )
}
